import React, { useEffect } from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';

const STATIC_BRIEFING_SRC =
  '/embedded/hospitals/index.html?portalRoute=/insights/hospitals';

const HospitalsBriefingPage = () => {
  useEffect(() => {
    window.location.replace(STATIC_BRIEFING_SRC);
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        px: 2,
        background:
          'radial-gradient(circle at top left, rgba(15,118,110,0.05), transparent 30%), linear-gradient(180deg, #f8f8f7 0%, #efefec 100%)',
      }}
    >
      <Stack spacing={1.5} alignItems="center">
        <CircularProgress size={28} thickness={4.2} sx={{ color: '#0f766e' }} />
        <Typography sx={{ color: 'rgba(24,24,27,0.72)' }}>
          Abrindo executive briefing...
        </Typography>
      </Stack>
    </Box>
  );
};

export default HospitalsBriefingPage;
